import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import moment from 'moment/moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMonth } from '../../data/format-month';
import Loading from '../../component/Loading';
import { apiPublicService } from '../../api';

const BlogSidebar = (props) => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);

  const formatDate = (date) => {
    const month = date.split('T')[0].split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY, HH:mm`)}`;
  };

  useEffect(() => {
    const lang = language === 'tk' ? 'tm' : language;
    let params = {
      limit: 6,
      offset: 0,
    };
    setLoading(true);
    apiPublicService.get(`/news/?lang=${lang}&limit=${params.limit}&offset=${params.offset}`)
      .then((res) => {
        setNews(res?.data.results);
        setLoading(false);
      }).catch((err) => {
      console.error(err);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <div className="sidebar-widget-wrapper">
      <div className="sidebar__widget mb-30">
        <div className="sidebar__widget-head mb-35">
          <h4 className="sidebar__widget-title">{t('other_news')}</h4>
        </div>
        {loading ?
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            margin: '20% auto',
          }}>
            <Loading />
          </div>
          :
          <div className="sidebar__widget-content">
            <div className="rc__post-wrapper">
              {
                Array.isArray(news) && news.length > 0 && news.map((item) => {
                  return (
                    <Link
                      key={item.id}
                      to={`/news-details/${item.id}`}>
                      <div className="tw-my-3 tw-flex tw-items-center tw-gap-1.5">
                        <div className="tw-basis-1/2 tw-aspect-[3/2] tw-bg-sky-100">
                          {item.image_thumbnail &&
                            <img src={item.image_thumbnail}
                                 className="tw-w-full tw-aspect-[3/2] tw-object-contain"
                                 alt="img not found" />}
                        </div>
                        <div className="tw-basis-1/2 rc__content">
                          <div className="rc__meta">
                            <span className="tw-capitalize">{formatDate(item.published_date)}</span>
                          </div>
                          <h6 className="rc__title">
                            {item.title}
                          </h6>
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default BlogSidebar;